import Image from '@atoms/Image';
import Tag from '@atoms/Tag';
import Link from 'next/link';
import type { ReactElement } from 'react';

import {
  CardTitle,
  CardWrapper,
  ImageWrapper,
} from './RelatedArticleCard.styled';
import type { RelatedArticleCardProps } from './RelatedArticleCard.types';

export const RelatedArticleCard = ({
  image,
  title,
  tag,
  link,
}: RelatedArticleCardProps): ReactElement => (
  <CardWrapper>
    <Link href={link}>
      <ImageWrapper>
        <Image alt={image.alt} src={image.src} fill />
      </ImageWrapper>
      <Tag link={tag.link} title={tag.title} />
      <CardTitle>{title}</CardTitle>
    </Link>
  </CardWrapper>
);
